import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Reproducibility_Report_Table = ({ setEdit }) => {
  const data = [
    {
      date: "01 Jan 2025",
      testParameter: "IM",
      performedBy: "Rajesh Kumar",
      method: "IS 1350 Part-I",
      certifiedValue: 24.5,
      observations: {
        day01: 55,
        day02: 55,
        day03: 55,
        day04: 55,
        day05: null,
      },
      average: 0.0103,
      stdDeviation: 0.0103,
      rsd: "0.26%",
    },
    {
      date: "01 Jan 2025",
      testParameter: "",
      performedBy: "Rajesh Kumar",
      method: "IS 1350 Part-I",
      certifiedValue: 24.5,
      observations: {
        day01: 55,
        day02: 55,
        day03: 55,
        day04: 55,
        day05: null,
      },
      average: 0.0103,
      stdDeviation: 0.0103,
      rsd: "0.26%",
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th rowspan="2">
                  <input type="checkbox" />
                </th>
                <th rowspan="2">Date</th>
                <th rowspan="2">Test Parameter</th>
                <th rowspan="2">Test Performed By</th>
                <th rowspan="2">Test Method</th>
                <th rowspan="2">Certified Value</th>
                <th colspan="5">Observations</th>
                <th rowspan="2">Avg.</th>
                <th rowspan="2">Std Deviation</th>
                <th rowspan="2">RSD%</th>
              </tr>
              <tr>
                <th>DAY 01</th>
                <th>DAY 02</th>
                <th>DAY 03</th>
                <th>DAY 04</th>
                <th>DAY 05</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.date}</td>
                  <td>{row.testParameter}</td>
                  <td>{row.performedBy}</td>
                  <td>{row.method}</td>
                  <td>{row.certifiedValue}</td>
                  <td>{row.observations.day01}</td>
                  <td>{row.observations.day02}</td>
                  <td>{row.observations.day03}</td>
                  <td>{row.observations.day04}</td>
                  <td>{row.observations.day05 ?? "-"}</td>
                  <td>{row.average}</td>
                  <td>{row.stdDeviation}</td>
                  <td>{row.rsd}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Reproducibility_Report_Table;
